import { render, staticRenderFns } from "./HernieuwbareEnergieScore.vue?vue&type=template&id=0a1b5806"
import script from "./HernieuwbareEnergieScore.vue?vue&type=script&lang=ts"
export * from "./HernieuwbareEnergieScore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports